<div class="main-container">
    <div class="header">
        <p>CREATE OFFER</p>
        <mat-icon class="close-icon" (click)="closeDialog(false)">close</mat-icon>
    </div>
    <app-offer-creation-simplified [popUpMode]="true" (messageEvent)="receiveMessage($event)"></app-offer-creation-simplified>
</div>
